const blockSlider = $('[data-slider="sliderBlock"]');
const globalSlider = $('[data-slider="globalBlock"]');

$( document ).ready(function() {
	if (blockSlider.length) {
		blockSlider.slick({
			arrows: true,
			infinite: true,
			slidesToShow: 5,
			centerMode: true,
			nextArrow: '<svg class="slick-next" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 8.66486L2.50981 16.6504L0.941176 14.978L6.86276 8.66486L0.941177 2.3517L2.50981 0.679331L10 8.66486Z" fill="black"/></svg>',
			prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path d="M-5.96308e-07 8.66473L7.49019 0.6792L9.05882 2.35157L3.13723 8.66473L9.05882 14.9779L7.49019 16.6503L-5.96308e-07 8.66473Z" fill="black"/></svg>',
			autoplay: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 425,
					settings: {
						slidesToShow: 1,
						centerMode: false,
					},
				},
			],
		});
	}

	if (globalSlider.length) {
		globalSlider.slick({
			arrows: true,
			infinite: true,
			slidesToShow: 2,
			autoplay: true,
			autoplaySpeed: 4000,
			nextArrow: '<svg class="slick-next" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1411 0.728577C6.83041 0.728577 0.882324 6.67666 0.882324 13.9874C0.882324 21.2981 6.83041 27.2462 14.1411 27.2462C21.4519 27.2462 27.4 21.2981 27.4 13.9874C27.4 6.67666 21.4519 0.728577 14.1411 0.728577ZM14.1411 25.9214C7.5604 25.9214 2.20712 20.5681 2.20712 13.9874C2.20712 7.40665 7.5604 2.05338 14.1411 2.05338C20.7219 2.05338 26.0752 7.40665 26.0752 13.9874C26.0752 20.5681 20.7219 25.9214 14.1411 25.9214Z" fill="black"/><path d="M20.3705 13.517L16.6448 9.7913C16.3853 9.53175 15.9689 9.53175 15.7093 9.7913C15.4498 10.0509 15.4498 10.4672 15.7093 10.7268L18.3049 13.3223L8.38239 13.3223C8.01469 13.3223 7.71729 13.6197 7.71729 13.9874C7.71729 14.3551 8.01469 14.6525 8.38239 14.6525L18.2995 14.6525L15.7039 17.248C15.4444 17.5076 15.4444 17.924 15.7039 18.1835C15.9635 18.4431 16.3799 18.4431 16.6394 18.1835L20.3651 14.4578C20.4949 14.3281 20.5597 14.1604 20.5597 13.9874C20.5597 13.8144 20.5003 13.6467 20.3705 13.517Z" fill="black"/></svg>',
			prevArrow: '<svg class="slick-prev" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2588 26.5176C20.5696 26.5176 26.5176 20.5696 26.5176 13.2588C26.5176 5.94808 20.5696 -2.59999e-07 13.2588 -5.79561e-07C5.94808 -8.99124e-07 -2.59999e-07 5.94808 -5.79561e-07 13.2588C-8.99124e-07 20.5696 5.94808 26.5176 13.2588 26.5176ZM13.2588 1.3248C19.8396 1.3248 25.1928 6.67808 25.1928 13.2588C25.1928 19.8396 19.8396 25.1928 13.2588 25.1928C6.67807 25.1928 1.3248 19.8396 1.3248 13.2588C1.3248 6.67808 6.67808 1.3248 13.2588 1.3248Z" fill="black"/><path d="M7.02948 13.7294L10.7551 17.455C11.0147 17.7146 11.4311 17.7146 11.6906 17.455C11.9502 17.1955 11.9502 16.7791 11.6906 16.5196L9.09509 13.924L19.0176 13.924C19.3853 13.924 19.6827 13.6266 19.6827 13.2589C19.6827 12.8912 19.3853 12.5938 19.0176 12.5938L9.1005 12.5938L11.696 9.9983C11.9556 9.73875 11.9556 9.32238 11.696 9.06283C11.4365 8.80328 11.0201 8.80328 10.7606 9.06283L7.03489 12.7885C6.90511 12.9183 6.84022 13.0859 6.84022 13.2589C6.84022 13.432 6.8997 13.5996 7.02948 13.7294Z" fill="black"/></svg>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	}
});



// WEBPACK FOOTER //
// ./scripts/modules/slick-slider.js